<div class="skeleton-product-card animated-skeleton-loading">
  <div class="skeleton-product-card__image"></div>
  <div class="skeleton-product-card__contents-container">
    <div class="skeleton__field skeleton__field__md skeleton-product-card__title"></div>
    <div>
      <div class="skeleton__field skeleton__field__xs skeleton-product-card__description"></div>
      <div class="skeleton__field skeleton__field__xs skeleton-product-card__description"></div>
      <div class="skeleton__field skeleton__field__xs skeleton-product-card__description"></div>
    </div>
    <div class="skeleton-product-card__attributes">
      <div class="skeleton__field skeleton__field__md skeleton-product-card__attribute"></div>
      <div class="skeleton__field skeleton__field__md skeleton-product-card__attribute"></div>
      <div class="skeleton__field skeleton__field__md skeleton-product-card__attribute"></div>
    </div>
    <!-- <div class="skeleton__field skeleton__field__md skeleton-product-card__footer"></div> -->
  </div>
</div>
